import React from 'react';
import PropTypes from 'prop-types';

import { st, classes } from './Divider.st.css';
import { DIRECTIONS, SKINS } from './Divider.constants';
import { DividerProps } from './Divider.types';

const Divider = ({
  dataHook,
  className,
  direction = DIRECTIONS.horizontal,
  skin = SKINS.light,
}: DividerProps) => (
  <hr
    data-hook={dataHook}
    className={st(classes.root, { direction, skin }, className)}
  />
);

Divider.displayName = 'Divider';

Divider.propTypes = {
  dataHook: PropTypes.string,
  className: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(DIRECTIONS)),
  skin: PropTypes.oneOf(Object.values(SKINS)),
};

export default Divider;
